// NPM Modules
import React from 'react';
// Components
import MarkdownDocument from '.';
// Documents
import privacy_policy from '../../../documents/privacy_policy.md';
// Component
export default () => <MarkdownDocument source={privacy_policy} />;
